export enum E_CandleValueType {
    OPEN = "Open",
    CLOSE = "Close",
    UNSET = "UnSet"
}
